document.addEventListener("DOMContentLoaded", function () {
    function updateParentClass() {
        const containers = document.querySelectorAll('.size-chart-group');
        containers.forEach(container => {
            const isChecked = container.querySelector('input:checked');
            const isSelectedClass = container.querySelector('.block-swatch.is-selected');
            if (isChecked || isSelectedClass) {
                container.classList.add('active-parent-group');
            } else {
                container.classList.remove('active-parent-group');
            }
        });
    }
    window.lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        smooth: true,
        prevent: (node) => node.hasAttribute('data-lenis-prevent') || node.closest('[data-lenis-prevent]'),
    });

    function raf(time) {
        window.lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    updateParentClass();
    document.addEventListener('change', function (e) {
        if (e.target.matches('.size-chart-group input')) {
            updateParentClass();
        }
    });

    const scrollableDivs = document.querySelectorAll('.pta-modal-body, .scrollable-content');
    scrollableDivs.forEach(div => {
        div.addEventListener('wheel', (e) => {
            e.stopPropagation();
        }, { passive: false });

        div.addEventListener('touchmove', (e) => {
            e.stopPropagation();
        }, { passive: false });
    });

    const quickBuyModal = document.querySelector('quick-buy-modal');
    const observer = new MutationObserver((mutationsList) => {
        const productRerender = quickBuyModal.querySelector('product-rerender');

        if (productRerender) {
            document.body.style.overflow = 'hidden';  
            if (window.lenis) {
                window.lenis.stop();  
            }
        } else {
            document.body.style.overflow = '';  
            if (window.lenis) {
                window.lenis.start();  
            }
        }
    });

    const config = {
        childList: true, 
        subtree: true,  
    };

    if (quickBuyModal) {
        observer.observe(quickBuyModal, config);
    }


});